import { FaBoltLightning } from 'react-icons/fa6';
import {
    AutoFixHigh,
    Celebration,
    HourglassTop,
    Moving,
    Pending,
    Timelapse,
} from '@mui/icons-material';

export const searchFilters = () => {
    return [
        { text: 'Latest', value: 'latest', icon: <FaBoltLightning /> },
        //  { text: 'Popular', value: 'popular', icon: <Celebration /> },
        { text: 'Trending', value: 'trending', icon: <Moving /> },
        { text: 'Random', value: 'random', icon: <AutoFixHigh /> },
        { text: 'Coming Soon', value: 'coming-soon', icon: <HourglassTop /> },
    ];
};
